import axios from "axios";
import { decodePayload } from "./connection";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_SERVER_SIDE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
let isRefreshing = false;
let refreshPromise = null;

function almostExpire(exp, graceMs = 300000) {
  if (!exp) return false;
  const currentTime = Date.now();
  const expirationTime = parseInt(exp);
  if (currentTime >= expirationTime) {
    return true;
  }
  return currentTime >= expirationTime - graceMs;
}

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    const exp = localStorage.getItem("exp");

    if (config.url?.startsWith("/public/")) {
      return config;
    }

    if (token && exp) {
      if (almostExpire(exp)) {
        if (isRefreshing && refreshPromise) {
          try {
            const newToken = await refreshPromise;
            config.headers.Authorization = `Bearer ${newToken}`;
            return config;
          } catch (error) {
            return Promise.reject(error);
          }
        }

        isRefreshing = true;
        refreshPromise = (async () => {
          try {
            const response = await axios.post(
              `${process.env.VUE_APP_SERVER_SIDE_URL}/user/refresh-token`,
              { token },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const newToken = response.data.token;
            localStorage.setItem("token", newToken);

            const newPayload = decodePayload(newToken);
            if (newPayload && newPayload.exp) {
              localStorage.setItem("exp", (newPayload.exp * 1000).toString());
              console.log(
                "Token refreshed (files), new exp:",
                new Date(newPayload.exp * 1000).toLocaleString()
              );
            }

            return newToken;
          } catch (error) {
            console.error("Token refresh failed (files):", error);
            const route = window.location.pathname;
            if (!route.startsWith("/public/") && !route.startsWith("/auth/")) {
              localStorage.clear();
              window.location.href = "/auth/login";
            }
            throw error;
          } finally {
            isRefreshing = false;
            refreshPromise = null;
          }
        })();

        try {
          const newToken = await refreshPromise;
          config.headers.Authorization = `Bearer ${newToken}`;
        } catch (error) {
          return Promise.reject(error);
        }
      } else {
        // Token válido
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !error.config._retry) {
      error.config._retry = true;

      const route = window.location.pathname;
      if (!route.startsWith("/public/") && !route.startsWith("/auth/")) {
        localStorage.clear();
        window.location.href = "/auth/login";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
